{
  "syncfusion": {
    "licenseKey": "Ngo9BigBOggjGyl/Vkd+XU9FcVRDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3tTf0VkWH5beXBVRGRfVE91Xg=="
  },
  "mapboxgl": {
    "accessToken": "pk.eyJ1IjoiZmVsaWNpdHl0b29scyIsImEiOiJjbXBtZ2puMnQwZjZ2MnJxdWwxMnppb2hhIn0._OZ-rhq-gEV2Y6Z_NYGG4Q"
  }
}